import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export default function VideoPreview({ video, isLoading }) {
  return (
    <div className="w-[551px] h-[310px] rounded-md overflow-hidden bg-gray-700">
      {isLoading ? (
        <div className="w-full h-full bg-gray-300 animate-pulse" />
      ) : video.thumbnail_video_preview?.gatsbyImageData ? (
        <GatsbyImage
          image={getImage(video.thumbnail_video_preview.gatsbyImageData)}
          alt="Video preview"
          className="w-full h-full"
          objectFit="cover"
        />
      ) : video.thumbnail_video_preview?.url ? (
        <img
          src={video.thumbnail_video_preview.url}
          alt="Video preview"
          className="w-full h-full object-cover"
          onError={(e) => {
            // Fallback to main thumbnail if preview fails
            if (video.thumbnail?.url) {
              e.target.src = video.thumbnail.url;
            }
          }}
        />
      ) : video.thumbnail?.gatsbyImageData ? (
        <GatsbyImage
          image={getImage(video.thumbnail.gatsbyImageData)}
          alt="Video preview"
          className="w-full h-full"
          objectFit="cover"
        />
      ) : (
        <div className="w-full h-full bg-gray-600 flex items-center justify-center text-white">
          Preview unavailable
        </div>
      )}
    </div>
  );
}
